import { ArrowUpRight } from "lucide-react";

// Gradient palette matching Lingora-style vivid color blocks
// Uses inline style to avoid Tailwind purge issues with dynamic classes
const COLOR_MAP = {
  blue:    { bg: "linear-gradient(135deg, #60a5fa 0%, #2563eb 100%)", shadow: "0 8px 24px rgba(37,99,235,0.35)" },
  violet:  { bg: "linear-gradient(135deg, #a78bfa 0%, #7c3aed 100%)", shadow: "0 8px 24px rgba(124,58,237,0.35)" },
  emerald: { bg: "linear-gradient(135deg, #34d399 0%, #059669 100%)", shadow: "0 8px 24px rgba(5,150,105,0.30)" },
  red:     { bg: "linear-gradient(135deg, #f87171 0%, #dc2626 100%)", shadow: "0 8px 24px rgba(220,38,38,0.30)" },
  amber:   { bg: "linear-gradient(135deg, #fbbf24 0%, #d97706 100%)", shadow: "0 8px 24px rgba(217,119,6,0.35)" },
  rose:    { bg: "linear-gradient(135deg, #fb7185 0%, #e11d48 100%)", shadow: "0 8px 24px rgba(225,29,72,0.30)" },
  sky:     { bg: "linear-gradient(135deg, #38bdf8 0%, #0284c7 100%)", shadow: "0 8px 24px rgba(2,132,199,0.30)" },
  navy:    { bg: "linear-gradient(135deg, #3b6baf 0%, #1e3a5f 100%)", shadow: "0 8px 24px rgba(30,58,95,0.35)" },
};

export default function StatCard({
  icon: Icon,
  label,
  value,
  sublabel,
  accent,
  color,      // new: key from COLOR_MAP → renders colored block card
  testId,
}) {
  if (color && COLOR_MAP[color]) {
    const { bg, shadow } = COLOR_MAP[color];
    return (
      <div
        data-testid={testId}
        className="flex flex-col gap-3 rounded-2xl p-5 transition-all duration-200 hover:-translate-y-1 cursor-default print:shadow-none"
        style={{ background: bg, boxShadow: shadow }}
      >
        <div className="flex items-start justify-between">
          <div
            className="flex h-11 w-11 items-center justify-center rounded-xl"
            style={{ background: "rgba(255,255,255,0.22)" }}
          >
            <Icon className="h-5 w-5 text-white" strokeWidth={2} />
          </div>
          <ArrowUpRight className="h-4 w-4 print:hidden" style={{ color: "rgba(255,255,255,0.45)" }} strokeWidth={2} />
        </div>
        <div>
          <div className="text-[11px] font-semibold uppercase tracking-[0.08em]" style={{ color: "rgba(255,255,255,0.80)" }}>
            {label}
          </div>
          <div className="mt-1 font-display text-3xl font-bold text-white">{value}</div>
          {sublabel && (
            <div className="mt-0.5 text-[11px]" style={{ color: "rgba(255,255,255,0.70)" }}>
              {sublabel}
            </div>
          )}
        </div>
      </div>
    );
  }

  // Default: white card with accent icon
  return (
    <div
      data-testid={testId}
      className="flex flex-col gap-3 rounded-2xl border border-gray-100 bg-white p-5 shadow-sm transition-all duration-200 hover:shadow-md hover:-translate-y-0.5 print:shadow-none print:translate-y-0"
    >
      <div className="flex items-start justify-between">
        <div
          className={`flex h-11 w-11 items-center justify-center rounded-xl ${
            accent || "bg-blue-50 text-[#1e3a5f]"
          }`}
        >
          <Icon className="h-5 w-5" strokeWidth={2} />
        </div>
        <ArrowUpRight className="h-4 w-4 text-gray-300 print:hidden" strokeWidth={2} />
      </div>
      <div>
        <div className="text-[11px] font-semibold uppercase tracking-[0.08em] text-slate-400">
          {label}
        </div>
        <div className="mt-1 font-display text-3xl font-bold text-slate-900">{value}</div>
        {sublabel && (
          <div className="mt-0.5 text-[11px] text-slate-400 leading-relaxed">{sublabel}</div>
        )}
      </div>
    </div>
  );
}
